import header from "./header";

let logout = {
  render: async () => {
    let view = /*html*/ `
        <div id="container" class="container-fluid">
          <div class="row text-center">
            <div class="col"><h1>Logged out<span></h1></div>
          </div>
        </div>
    `;
    return view;
  },
  after_render: async () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    localStorage.removeItem("sas_tokens");
    // rerender the header
    await header.after_render();
  },
};

export default logout;
